import { useRecordContext } from 'react-admin';
import { format } from 'date-fns';

interface TimeFieldProps {
  source: string;
  record?: any;
  emptyText?: string;
}

/**
 * Displays a timestamp as time only (HH:mm:ss format).
 */
export const TimeField = ({
  source,
  record: propRecord,
  emptyText,
}: TimeFieldProps) => {
  const contextRecord = useRecordContext();
  const record = propRecord || contextRecord;

  if (!record || !record[source])
    return emptyText ? <span>{emptyText}</span> : null;

  const date = new Date(record[source]);
  const timeString = format(date, 'HH:mm:ss');

  return <span>{timeString}</span>;
};
